import gsap from 'gsap';

/**
 * Animacja hero – start po załadowaniu strony (window load).
 * Kolejność:
 * 1. Opacity tła (block-hero__bg).
 * 2. Elementy lewo i prawo – całkowicie poza ekranem + opacity 0 → wjazd + fade in.
 * 3. Tekst (content-top, content-bottom, inner-content).
 */
export default function initializeHero() {
    const block = document.querySelector('.block-hero');
    if (!block) return;

    const bg = block.querySelector('.block-hero__bg');
    const patternLeft = block.querySelector('.block-hero__pattern-left');
    const patternRight = block.querySelector('.block-hero__pattern-right');
    const contentTop = block.querySelector('.block-hero__content-top');
    const contentBottom = block.querySelector('.block-hero__content-bottom');
    const innerContent = block.querySelector('.block-hero__inner-content');

    const hasBg = !!bg;
    const hasPatterns = !!(patternLeft || patternRight);
    const hasText = !!(contentTop || contentBottom || innerContent);
    if (!hasBg && !hasPatterns && !hasText) return;

    // Stan początkowy jest w CSS (brak migania i skoku – hero ukryty od pierwszej klatki)

    function runTimeline() {
        const tl = gsap.timeline({ defaults: { ease: 'power2.out' } });

        // 1. Opacity tła
        if (bg) {
            tl.to(bg, { opacity: 1, duration: 0.5, ease: 'power2.out' });
        }

        // 2. Elementy lewo i prawo – wjazd z poza ekranu + opacity 0 → 1
        const afterBg = hasBg ? '>0.1' : 0;
        if (patternLeft) {
            tl.to(patternLeft, { x: 0, opacity: 1, duration: 0.9, ease: 'power2.out' }, afterBg);
        }
        if (patternRight) {
            tl.to(patternRight, { x: 0, opacity: 1, duration: 0.9, ease: 'power2.out' }, afterBg);
        }

        // 3. Tekst – razem
        const textStart = '>0.2';
        if (contentTop) {
            tl.to(contentTop, { opacity: 1, duration: 0.5, ease: 'power2.out' }, textStart);
        }
        if (contentBottom) {
            tl.to(contentBottom, { opacity: 1, duration: 0.5, ease: 'power2.out' }, contentTop ? '<0' : textStart);
        }
        if (innerContent) {
            tl.to(innerContent, { opacity: 1, duration: 0.5, ease: 'power2.out' }, (contentTop || contentBottom) ? '<0' : textStart);
        }
    }

    // Start animacji dopiero gdy strona się w pełni załaduje (obrazy, style, itd.)
    if (document.readyState === 'complete') {
        runTimeline();
    } else {
        window.addEventListener('load', runTimeline);
    }
}
